export const GET_GROUP_STATUS_DATA_REQUEST = "GET_GROUP_STATUS_DATA_REQUEST";
export const GET_GROUP_STATUS_DATA_SUCCESS = "GET_GROUP_STATUS_DATA_SUCCESS";
export const GET_GROUP_STATUS_DATA_FAILURE = "GET_GROUP_STATUS_DATA_FAILURE";

export const POST_GROUP_STATUS_REQUEST = "POST_GROUP_STATUS_REQUEST";
export const POST_GROUP_STATUS_SUCCESS = "POST_GROUP_STATUS_SUCCESS";
export const POST_GROUP_STATUS_FAILURE = "POST_GROUP_STATUS_FAILURE";

export const UPDATE_GROUP_STATUS_REQUEST = "UPDATE_GROUP_STATUS_REQUEST";
export const UPDATE_GROUP_STATUS_SUCCESS = "UPDATE_GROUP_STATUS_SUCCESS";
export const UPDATE_GROUP_STATUS_FAILURE = "UPDATE_GROUP_STATUS_FAILURE";

export const UPDATE_GROUP_STATUS_ENTITY_PARAMS_SUCCESS = "UPDATE_GROUP_STATUS_ENTITY_PARAMS_SUCCESS";
export const UPDATE_GROUP_STATUS_ENTITY_PARAMS_FAILURE = "UPDATE_GROUP_STATUS_ENTITY_PARAMS_FAILURE";

export const STATUS_GROUP_DROPDOWN_REQUEST = "STATUS_GROUP_DROPDOWN_REQUEST";
export const STATUS_GROUP_DROPDOWN_SUCCESS = "STATUS_GROUP_DROPDOWN_SUCCESS";
export const STATUS_GROUP_DROPDOWN_FAILURE = "STATUS_GROUP_DROPDOWN_FAILURE";

export const DELETE_GROUP_STATUS_REQUEST = "DELETE_GROUP_STATUS_REQUEST";
export const DELETE_GROUP_STATUS_SUCCESS = "DELETE_GROUP_STATUS_SUCCESS";
export const DELETE_GROUP_STATUS_FAILURE = "DELETE_GROUP_STATUS_FAILURE";
